import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchRecruiter } from 'services/recruitersService';
import useUserId from './useUserId2';

const useFetchRecruiter = () => {
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
      company: "",
      email: "",
      first_name: "",
      last_name: "",
      image: "",
    });
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const userId = useUserId();
  useEffect(()=>{
    console.log('recruiter :',userId)
   },[formData])
  useEffect(() => {
    const loadRecruiter = async () => {
      // Guard clause: Only execute if userId is available
      if (!userId || !userId.userId) {
        console.log('Waiting for userId to be available...');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const data = await fetchRecruiter(userId.userId);
        setFormData(data);
      } catch (error) {
        if (error.message === "Unauthorized") {
          console.log("Unauthorized. Redirecting to login page ...");
          navigate("/login");
          return;
        }
        console.error("Error loading recruiter:", error);
        setError("Failed to fetch recruiter data");
      } finally {
        setLoading(false);
      }
    };

    loadRecruiter();
  }, [userId, navigate]);

  return { formData, loading, error };
};

export default useFetchRecruiter;